export const GamesIdKenoMatch = [36, 37, 40, 41];
export const GamesIdMiniKeno = [12, 13, 14, 15, 16, 17, 18, 19, 52, 53];
export const NUMBER_ROWS_DISPLAY = 30;
export const InfiniteLoadBeginEdgeOffset = 20;
